import { useFetch } from '../hooks';
import history from '../history';
import { ADMIN_API_URL } from '../config';

export function useAdminFetch(url, options = {}) {
  options.unauthorized = () => history.push('/root/login');
  return useFetch(`${ADMIN_API_URL}/${url}`, options);
}